
import { IntlShape, PrimitiveType } from 'react-intl';
import { FormatMessageType, Options } from '../../common/types'

export const translateInputOptions = (optionObject: Options, formatMessage: FormatMessageType) =>
  Object.entries(optionObject.options).map(([key, value]) => {
    return {
      value: key,
      label: formatMessage({
        id: value,
      }),
    }
  })

/** Safe wrapper around intl.formatMessage() */
export function formatMessageSafe(intl: IntlShape): FormatMessageType {
  return function formatMessageSafe(messageObj: any, values?: Record<string, PrimitiveType>): string {

    if(typeof messageObj === "string") {
      return messageObj;
    }

    try {
      return intl.formatMessage(messageObj, values)
    } catch (e) {
      console.error('[translateMessage] Failed to format message:' + JSON.stringify(messageObj) + " [Error]: " + JSON.stringify(e))

      const id = messageObj && messageObj.id ? messageObj.id : ''
      const defaultMessage = messageObj && messageObj.defaultMessage ? messageObj.defaultMessage : ''

      if(defaultMessage) {
        return defaultMessage
      }
      
      return id ? id : ''
    }
  }
}
